import { useCallback, useRef, useState } from "react";

// Presentation feedback only; each page keeps its existing API and data handling.
export function useLoadFeedback(resourceKey) {
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [error, setError] = useState("");
  const request = useRef(0);
  const loaded = useRef(false);
  const previousKey = useRef(resourceKey);
  const run = useCallback(async (load) => {
    const current = ++request.current;
    if (previousKey.current !== resourceKey) {
      previousKey.current = resourceKey;
      loaded.current = false;
      setHasLoaded(false);
    }
    setLoading(!loaded.current);
    setRefreshing(true);
    setError("");
    try {
      await load();
      if (current === request.current) {
        loaded.current = true;
        setHasLoaded(true);
      }
    } catch {
      if (current === request.current) setError("Data belum dapat dimuat. Periksa koneksi Anda, lalu coba lagi.");
    } finally {
      if (current === request.current) {
        setLoading(false);
        setRefreshing(false);
      }
    }
  }, [resourceKey]);
  return { loading, refreshing, hasLoaded, error, run };
}
